import React, {forwardRef, useMemo} from "react"
import {Bar} from "react-chartjs-2"
import {Box} from "@mui/material"
import {
    BarElement,
    CategoryScale,
    Chart,
    Legend,
    LinearScale,
    Title,
    Tooltip,
} from "chart.js"
import {
    buildStackedBarchartOptions,
    legendPositionMap,
} from "../stacked-barchart-options"

Chart.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)
Chart.defaults.plugins.legend.display = false

const ChartLayer = forwardRef(({chart, legend, height}, ref) => {
    const legendEntry = legendPositionMap[legend] ?? legendPositionMap.NONE

    const chartData = useMemo(
        () => ({
            labels: chart?.bottomLabels ?? [],
            datasets: chart?.datasets ?? [],
        }),
        [chart],
    )

    const options = useMemo(() => {
        const base = buildStackedBarchartOptions(chart?.bottomLabels ?? [], legendEntry)
        return {
            ...base,
            datasets: {
                ...base.datasets,
                bar: {
                    ...base.datasets.bar,
                    categoryPercentage: 0.76,
                    barPercentage: 0.85,
                },
            },
            scales: {
                ...base.scales,
                titles: {
                    ...base.scales.titles,
                    ticks: {...base.scales.titles.ticks, display: false},
                },
            },
        }
    }, [chart?.bottomLabels, legendEntry])

    return (
        <Box
            ref={ref}
            sx={{
                position: "relative",
                width: "100%",
                height: `${height}px`,
            }}
        >
            <Bar options={options} data={chartData} />
        </Box>
    )
})

ChartLayer.displayName = "ChartLayer"

export default ChartLayer
